export const downloadAsFile = (
  name: string,
  type: string,
  content: string
): boolean => {
  const bom = "\uFEFF";
  const blob = new Blob([bom, content], { type });

  // IE
  if (navigator.msSaveBlob) {
    return navigator.msSaveBlob(blob, name);
  }

  // add hidden node
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.setAttribute("style", "display: none;");
  a.setAttribute("href", url);
  a.setAttribute("download", name);

  // download
  document.body.appendChild(a);
  a.click();

  // clean
  window.URL.revokeObjectURL(url);
  a.remove();
  return true;
};
